import { DateTime } from 'luxon'

export const getFormattedTime = (datetime: DateTime, units: 'metric' | 'us', timezone?: string): string => {
  const locale = units === 'metric' ? 'de-DE' : 'en-US'
  return timezone
    ? datetime.setZone(timezone).setLocale(locale).toLocaleString(DateTime.TIME_SIMPLE)
    : datetime.setLocale(locale).toLocaleString(DateTime.TIME_SIMPLE)
}

export const getFormattedDate = (datetime: DateTime, units: 'metric' | 'us', timezone?: string): string => {
  const locale = units === 'metric' ? 'de-DE' : 'en-US'
  return timezone
    ? datetime.setZone(timezone).setLocale(locale).toLocaleString(DateTime.DATE_SHORT)
    : datetime.setLocale(locale).toLocaleString(DateTime.DATE_SHORT)
}

export const getFormattedDateTime = (datetime: DateTime, units: 'metric' | 'us', timezone?: string): string => {
  const locale = units === 'metric' ? 'de-DE' : 'en-US'
  return timezone
    ? datetime.setZone(timezone).setLocale(locale).toLocaleString(DateTime.DATETIME_SHORT)
    : datetime.setLocale(locale).toLocaleString(DateTime.DATETIME_SHORT)
}
